import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {map, Observable} from "rxjs";
import {environment} from "@env/environment";
import {
  GrantedRole,
  RoleGrantedUser,
  RoleGroupModule,
  UngroupedRole
} from "@features/rbac-grants/grants-role-groups/grants-role-groups.model";

@Injectable({
  providedIn: 'root'
})
export class GrantsRoleGroupsService {
  private _apiUrl = environment.apiSecurityHost + '/console/rbac/offering';
  private _grantsRolesEndpoint = '/grants/roles';
  private _http = inject(HttpClient);


  getAssignableConsoleRoles(): Observable<Set<RoleGroupModule>> {
    const url = this._apiUrl + '/role-groups';
    console.log(url);
    return this._http.get<Set<RoleGroupModule>>(url);
  }

  private rolesEndpoint(): string {
    return `${this._apiUrl}${this._grantsRolesEndpoint}`;
  }

  getGrantedUsersForRoles(roleCodes: string[]): Observable<Map<GrantedRole, Set<RoleGrantedUser>>> {
    return this._http.post<Map<GrantedRole, Set<RoleGrantedUser>>>(this.rolesEndpoint(), {roleCodes: roleCodes});
  }

  getGrantedUsersForRole(roleCode: string): Observable<RoleGrantedUser[]> {
    return this._http.post<Map<GrantedRole, Set<RoleGrantedUser>>>(this.rolesEndpoint(), {roleCodes: [roleCode]}).pipe(
      map(response => {
        const [users] = Object.values(response).map(users => Array.from(users));
        return users.map(user => new RoleGrantedUser(user));
      })
    );
  }

  getGrantedUsersForUngroupedRoles(): Observable<UngroupedRole[]> {
    const endpoint = `${this._apiUrl}/grants/role-groups/ungrouped`;
    return this._http.get<UngroupedRole[]>(endpoint);
  }

}
